import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var EraseIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M2 21h20a1 1 0 01.117 1.993L22 23H2a1 1 0 01-.117-1.993L2 21h20zM15.03 3.836l.15.138 2.817 2.762a3.305 3.305 0 01.146 4.591l-.138.143-8.412 8.244a1 1 0 01-.572.278L8.89 20l-3.373-.008a1 1 0 01-.6-.201l-.098-.085-2.817-2.761a3.305 3.305 0 01-.146-4.591l.138-.143 8.412-8.245c1.27-1.244 3.294-1.286 4.623-.13zM4.823 12.238l-1.429 1.401a1.302 1.302 0 00-.091 1.769l.1.109 2.526 2.476L8.486 18l1.059-1.039-4.722-4.722zm7.096-6.942l-.112.099-5.555 5.442 4.722 4.722 5.632-5.518a1.302 1.302 0 00.091-1.768l-.1-.109-2.817-2.761a1.423 1.423 0 00-1.86-.107z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
EraseIcon.isCarinaIcon = true;
export default EraseIcon;
